export default "__VITE_ASSET__CJ1AUhZ9__"